// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "dd704a17cfa73975806f3456dc64c4e7" + ".js";
};